module.exports = __webpack_public_path__ + "static/img/4.f66855d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/1/sp/4.png
// module id = 6P8Z
// module chunks = 0